import { render, staticRenderFns } from "./shareCode.vue?vue&type=template&id=164a2898&scoped=true&"
import script from "./shareCode.vue?vue&type=script&lang=ts&"
export * from "./shareCode.vue?vue&type=script&lang=ts&"
import style0 from "./shareCode.vue?vue&type=style&index=0&id=164a2898&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "164a2898",
  null
  
)

export default component.exports